
  import {AfterViewInit, Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
  import {Chart} from 'chart.js';
  import {Router} from '@angular/router';
  import {Store} from '@ngrx/store';
  import {AppState, selectAuthState, selectDoctorState} from '../../../../store/app.states';
  import {DoctorService} from '../../../../services/doctor.service';
  import {MatDialog} from '@angular/material/dialog';
  import {Observable, Subscription} from 'rxjs';
  import {MatTableDataSource} from '@angular/material/table';
  import {Patient} from '../../../../model/user/Patient';
  import {MatPaginator, MatPaginatorIntl, MatPaginatorModule, PageEvent} from '@angular/material/paginator';
  import {MatCheckboxChange} from '@angular/material/checkbox';
  import {MatSnackBar} from "@angular/material/snack-bar";

@Component({
  selector: 'app-bar-chart-never-logged-pathology-duration',
  templateUrl: './bar-chart-never-logged-pathology-duration.component.html',
  styleUrls: ['./bar-chart-never-logged-pathology-duration.component.css']
})
export class BarChartNeverLoggedPathologyDurationComponent implements OnInit {


            // per inizializzazione
            getAuthState: Observable<any>;
            getDoctorState: Observable<any>;
            isAuthenticated: boolean;
            user = null;
            errorMessage = null;
            subscription1: Subscription;
            subscription2: Subscription;
            subscription3: Subscription;
            subscription4: Subscription;
            subscription5: Subscription;
            subscription6: Subscription;
            title = "Durata patologia";
            destination = 'never-logged';
  
            // elementi che servono per il bar-chart
            canvas: any;
            ctx: any;
            myChartNeverLoggedPatients: Chart;
      
            // ******************************************************************************************************************
            // seguenti righe: inizializzazione dei pazienti 
            // ******************************************************************************************************************
            neverLoggedGlobalFasciaA = 0;
            neverLoggedGlobalFasciaB = 0;
            neverLoggedGlobalFasciaC = 0;
            neverLoggedGlobalFasciaD = 0;
  
      
            loggedGlobalFasciaA = 0;
            loggedGlobalFasciaB = 0;
            loggedGlobalFasciaC = 0;
            loggedGlobalFasciaD = 0;
  
      
      
            GlobalPatientsFasciaA = 0;
            GlobalPatientsFasciaB = 0;
            GlobalPatientsFasciaC = 0;
            GlobalPatientsFasciaD =0;
     
      
            neverLoggedGlobalPatientsArray = [];
            loggedGlobalPatientsArray = [];
            neverLoggedPatientsGlobal = [];
            // ******************************************************************************************************************
            // bar chart dei pazienti 
            // ******************************************************************************************************************
            public barChartLabelsGlobalNeverLogged = ['0-10', '10-20','20-30','30+'];
            public barChartTypeGlobalNeverLogged = 'horizontalBar';
            public barChartLegendGlobalNeverLogged = true;
            public barChartDataGlobalNeverLogged = [
              {
                data: this.loggedGlobalPatientsArray, label: 'Accesso effettuato', backgroundColor: ['teal', 'teal','teal', 'teal'],
                hoverBackgroundColor: ['#066', '#066','#066','#066'],maxBarPercentage : 0.5,  // number (pixels) or 'flex'
              },
              {
                data: this.neverLoggedGlobalPatientsArray, label: 'Accesso non effettuato', backgroundColor: ['orangered', 'orangered','orangered','orangered'],
                hoverBackgroundColor: ['#cc3700', '#cc3700','cc3700','cc3700'], maxBarPercentage: 0.5,  // number (pixels) or 'flex'
              }];
            
      
      
            // constructor
            constructor(private store: Store<AppState>,
                        private doctorService: DoctorService,
                        private snackBar: MatSnackBar) {
              this.getAuthState = this.store.select(selectAuthState);
              this.getDoctorState = this.store.select(selectDoctorState);
            }
            // ******************************************************************************************************************
            // metodo all'inizio
            ngOnInit(): void {
              this.subscription6 = this.getAuthState.subscribe((state) => {
                this.isAuthenticated = state.isAuthenticated;
                this.user = JSON.parse(localStorage.getItem('user'));
                this.errorMessage = state.errorMessage;
                this.retrieveGlobalNeverLoggedFasciaA();
              });
            }
            ngOnDestroy(): void {
              this.subscription1.unsubscribe();
              this.subscription2.unsubscribe();
              this.subscription3.unsubscribe();
              this.subscription4.unsubscribe();
              this.subscription5.unsubscribe();
              this.subscription6.unsubscribe();
            }
            // ******************************************************************************************************************
            // metodi che si richiamano in cascata e prendono tutti gli inattivi in telemedicina
            // e in standard e poi tutti
            // i pazienti in ogni categoria per poter calcolare gli attivi
            // retrieve global active and inactive patients (le funzioni si richiamano in cascata) bar chart
    
            retrieveGlobalNeverLoggedFasciaA() {
              this.subscription1 = this.doctorService.getNeverLoggedPathologyDurationBracketsNumber("0","10").subscribe(npatients => {
                this.neverLoggedGlobalFasciaA = parseInt(npatients.toString());
                this.neverLoggedGlobalPatientsArray.push(this.neverLoggedGlobalFasciaA); // riempio il vettore del bar chart con standard
                this.retrieveGlobalNeverLoggedFasciaB();
    
              }, error => {
                if (error.status === 500) {
                  localStorage.setItem('expirationTime', '0');
                  console.log('SESSIONE SCADUTA');
                  location.reload();
                }
              });
            }
            retrieveGlobalNeverLoggedFasciaB() {
              this.subscription2 = this.doctorService.getNeverLoggedPathologyDurationBracketsNumber("10","20").subscribe(npatients => {
                this.neverLoggedGlobalFasciaB = parseInt(npatients.toString());
                this.neverLoggedGlobalPatientsArray.push(this.neverLoggedGlobalFasciaB); // riempio vettore del bar-chart con telemedicina
                this.retrieveGlobalNeverLoggedFasciaC();
    
              }, error => {
                if (error.status === 500) {
                  localStorage.setItem('expirationTime', '0');
                  console.log('SESSIONE SCADUTA');
                  location.reload();
                }
              });
            }
  
            retrieveGlobalNeverLoggedFasciaC() {
              this.subscription3 = this.doctorService.getNeverLoggedPathologyDurationBracketsNumber("20","30").subscribe(npatients => {
                this.neverLoggedGlobalFasciaC = parseInt(npatients.toString());
                this.neverLoggedGlobalPatientsArray.push(this.neverLoggedGlobalFasciaC); // riempio vettore del bar-chart con telemedicina
                this.retrieveGlobalNeverLoggedFasciaD();
  
    
              }, error => {
                if (error.status === 500) {
                  localStorage.setItem('expirationTime', '0');
                  console.log('SESSIONE SCADUTA');
                  location.reload();
                }
              });
            }
    
            retrieveGlobalNeverLoggedFasciaD() {
              this.subscription4 = this.doctorService.getNeverLoggedPathologyDurationBracketsNumber("30","1000").subscribe(npatients => {
                this.neverLoggedGlobalFasciaD = parseInt(npatients.toString());
                this.neverLoggedGlobalPatientsArray.push(this.neverLoggedGlobalFasciaD); // riempio vettore del bar-chart con telemedicina
                this.retrieveGlobalPathologyDuration();
    
              }, error => {
                if (error.status === 500) {
                  localStorage.setItem('expirationTime', '0');
                  console.log('SESSIONE SCADUTA');
                  location.reload();
                }
              });
            }
          
            retrieveGlobalPathologyDuration() {
              this.subscription5 = this.doctorService.getGlobalPathologyDurationNumber().subscribe(num => {
                this.GlobalPatientsFasciaA = num[0];
                this.GlobalPatientsFasciaB = num[1];
                this.GlobalPatientsFasciaC = num[2];
                this.GlobalPatientsFasciaD = num[3];
    
                this.loggedGlobalFasciaA = this.GlobalPatientsFasciaA - this.neverLoggedGlobalFasciaA;
                this.loggedGlobalPatientsArray.push(this.loggedGlobalFasciaA); // riempio il vettore del bar chart con standard           
                this.loggedGlobalFasciaB = this.GlobalPatientsFasciaB - this.neverLoggedGlobalFasciaB;
                this.loggedGlobalPatientsArray.push(this.loggedGlobalFasciaB); // riempio il vettore del bar chart con telemedicina
                this.loggedGlobalFasciaC = this.GlobalPatientsFasciaC - this.neverLoggedGlobalFasciaC;
                this.loggedGlobalPatientsArray.push(this.loggedGlobalFasciaC); // riempio il vettore del bar chart con standard           
                this.loggedGlobalFasciaD = this.GlobalPatientsFasciaD - this.neverLoggedGlobalFasciaD;
                this.loggedGlobalPatientsArray.push(this.loggedGlobalFasciaD); // riempio il vettore del bar chart con standard           
                this.canvasSetting();
              }, error => {
                if (error.status === 500) {
                  localStorage.setItem('expirationTime', '0');
                  console.log('SESSIONE SCADUTA');
                  location.reload();
                }
              });
            }
           
            canvasSetting() {
                this.canvas = document.getElementById('myChartNeverLoggedPathologyDuration') as HTMLCanvasElement;
                this.ctx = this.canvas.getContext('2d');
                this.myChartNeverLoggedPatients = new Chart(this.ctx, {
                  type: this.barChartTypeGlobalNeverLogged,
                  data: {
                    labels: this.barChartLabelsGlobalNeverLogged,
                    datasets: this.barChartDataGlobalNeverLogged,
                  },
                  options: {
                    maintainAspectRatio: true,
                    responsive: true,
      
                    scales: {
                      xAxes: [{
                        display: true,
                        stacked: false,
                        ticks: {
                          fontSize: 12,
                          fontStyle: 'bold',
                          fontFamily: 'Helvetica',
                          fontColor: '#006192'
                        }
                      }],
                      yAxes: [{
                        display: true,
                        stacked: false,
                        ticks: {
                          fontSize: 12,
                          fontStyle: 'bold',
                          fontFamily: 'Helvetica',
                          fontColor: '#006192'
                        }
                      }],
                    },
                    legend: {
                     
                      display: true,
                      position: 'top',
                      labels: {
                        usePointStyle: true,
                        fontColor: '#006192',
                        fontSize: 18,
                        fontFamily: 'Helvetica',
                      }
                    },
                    tooltips: {
                      // content: '{pathology}: {number}',
                      backgroundColor: '#1c1c1c',
                      bodyFontSize: 18,
                      titleFontSize: 18,
                      cornerRadius: 5,
                      caretPadding: 10
                    },
                    title: {
                      display: true,
                      text: "N° di utenti che hanno/non hanno effettuato l'accesso",
                      fontColor: '#006192',
                      fontSize: 20,
                      fontFamily: 'Helvetica',
                    },
                    hover: {
                      mode: 'nearest',
                      intersect: true
                    }
                  }
                });
                } // dopo aver ottenuto tutti i dati creo il bar chart
            
          }
          